const { storage: { appStorage: AppStorage } } = relaylib;

angular.module('relayHealth').service('storageManager', function storageManager() {
  if (!this.storage) {
    this.storage = new AppStorage(relaylib.storage.storageTypes.localStorage);
    relaylib.storage.localstorage.localstorage = window.localStorage;
  }
});
